<template>
  <div class="modal fade" id="ModalModifierProdCondMagInv" tabindex="-1" role="dialog"
    ref="addModalModifierProdCondMagInvRef" aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Modification de l'inventaire</h4>
          <h6 v-if="item" class="modal-title" style="font-size:11px;">{{ item.nomProd }}</h6>
          <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <Form v-if="item" ref="modifierProdCondMagInvForm" @submit="editModalModifierProdCondMagInv"
            :validation-schema="modifierProdCondMagInvSchema">
            <div class="row">
              <div v-show="false" class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Id <span class="text-danger">*</span>
                  </label>
                  <Field v-model="item.id" name="id" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Id" />
                  <ErrorMessage name="id" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Stock Fiche <span class="text-danger">*</span>
                  </label>
                  <Field v-model="item.qteFiche" name="qteFiche" type="text"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="XX" />
                  <ErrorMessage name="qteFiche" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Stock Logique <span class="text-danger">*</span>
                  </label>
                  <Field v-model="item.qteLogique" name="qteLogique" type="text"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="XX" />
                  <ErrorMessage name="qteLogique" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Observation <span class="text-danger">*</span>
                  </label>
                  <Field v-model="item.observation" name="observation" type="textarea"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Une observation ?" />

                  <ErrorMessage name="observation" class="text-danger" />
                </div>
              </div>

              <button class="btn btn-primary" type="submit">
                Appliqué
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { hideModal } from '@/utils/utils';
import { Famille } from '@/models/Famille';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect'

export default defineComponent({
  name: "ModalModifierProdCondMagInv",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    item: {
      type: Object as () => any | null,
      default: null
    }
  },
  setup(props, { emit }) {
    const modifierProdCondMagInvSchema = Yup.object().shape({
      id: Yup.number().required("Renseigner l'id").typeError("Entrer un nombre"),
      qteFiche: Yup.number().min(0).required('La quantité fiche est obligatoire').typeError("Entrer un nombre"),
      qteLogique: Yup.number().min(0).required('La quantité logique est obligatoire').typeError("Entrer un nombre"),
      observation: Yup.string().required("L\'observation est obligatoire"),
    });

    const modifierProdCondMagInvForm = ref<Famille | null>(null);
    const addModalModifierProdCondMagInvRef = ref<null | HTMLElement>(null);
    const router = useRouter();
    const familleOptions = ref([]);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const item = ref();

    watch(() => props.item, (newValue) => {
      console.log("Nous somme à destination avec ceci ==> ", newValue)
      item.value = props.item;
      console.log("Nous TTTYTYYGHgh ==> ", item.value)
      isUPDATE.value = true;
    });


    onMounted(() => {
      console.log("Nous TTTYTYYGHgh ==> ", item.value)
    });


    const editModalModifierProdCondMagInv = async (values: any, modifierProdCondMagInvForm) => {
      console.log("UYYYYY ===> ",values);
      ApiService.put("/produitProdCondMagInv/"+values.id, values)
      .then(({ data }) => {
          if (data.code == 200) {
            success(data.message);
            hideModal(addModalModifierProdCondMagInvRef.value);
            emit('close');
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isUPDATE.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
    };

    return {
      modifierProdCondMagInvSchema,
      addModalModifierProdCondMagInvRef,
      editModalModifierProdCondMagInv,
      modifierProdCondMagInvForm,
      resetValue,
      familleOptions,
      item
    };
  },
});
</script>@/models/CategorieInfo